import React, { useEffect, useContext, useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import sendRequest from "../../api";

import Colors from "../../components/utils/Colors";
import goBack from "../../assets/images/cart/goBack.svg";
import notFounded from "../../assets/images/notFoundSearch.svg";
import styles from "./BlogList.module.scss";
import SText from "../../components/SText";

const BlogList = () => {
    const navigate = useNavigate();

    const [posts, setPosts] = useState([]);

    async function getContent() {
        const posts = await sendRequest("getBlogPosts", { start: 0 });
        if (posts && posts.records) {
            setPosts(posts.records);
        }
    }

    useEffect(() => {
        getContent();
    }, []);

    return (
        <div className={styles.wrapper}>
            <Helmet>
                <title>Блог о полезном питании</title>
                <meta
                    name="description"
                    content="Блог о полезном питании"
                    data-react-helmet="true"
                />
                <meta
                    name="keywords"
                    content="Блог о полезном питании"
                    data-react-helmet="true"
                />
            </Helmet>

            <div className={styles.header}>
                <div onClick={() => navigate("/")} className={styles.goBack}>
                    <img src={goBack} />
                </div>
                <SText size={16} lineHeight={16} weight={500}>
                    {"Блог"}
                </SText>
            </div>

            <h1>Блог</h1>
            <div className={styles.blogList}>
                {posts.length
                    ? posts.map((post, index) => {
                          return (
                              <div className={styles.blogPost} key={index}>
                                  <Link to={"/blog/" + post.url}>
                                      <div
                                          className={styles.blogPostImage}
                                          style={{
                                              background:
                                                  "url(https://api.ecomarket.ru" +
                                                  post.image +
                                                  ")",
                                          }}
                                      ></div>

                                      <SText
                                          title={post.title}
                                          size={14}
                                          lineHeight={15}
                                          weight={500}
                                          color={Colors.darkGray}
                                      >
                                          {post.title}
                                      </SText>
                                  </Link>
                              </div>
                          );
                      })
                    : null}
            </div>
        </div>
    );
};

export default BlogList;
